module.exports = __webpack_public_path__ + "static/media/B&TScreenshot4.bc2089ba.png";